import { TimelineOptionsItemsType } from './TimelineOptions.types';

export const sortOptions = (options: TimelineOptionsItemsType[]) =>
  options
    .sort(
      (firstDatetime, secondDatetime) =>
        new Date(firstDatetime.creationDateTime).getTime() -
        new Date(secondDatetime.creationDateTime).getTime()
    )
    .reverse();

export default {
  sortOptions
};
